import React, { useEffect, useRef } from "react";

const AnnouncementBar = ({ onHeightChange }) => {
  const ref = useRef(null);

  useEffect(() => {
    if (!ref.current) return;
    const update = () => onHeightChange(ref.current.offsetHeight);
    update();
    const observer = new ResizeObserver(update);
    observer.observe(ref.current);
    return () => observer.disconnect();
  }, [onHeightChange]);

  return (
    <div
      ref={ref}
      className="fixed top-0 left-0 right-0 z-[60] bg-gradient-to-r from-[#1ab8ac] via-[#30D5C8] to-[#1ab8ac] text-white py-3 px-4 text-center"
    >
      <p className="font-bold" style={{ fontSize: "1.375rem" }}>
        🎉 Full premium access is free until July 31st.
      </p>
    </div>
  );
};

export default AnnouncementBar;
